import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import AccountLayout from '../../components/Account/AccountLayout';
import SavedReports from '../../components/SavedReports/SavedReports';
import './AccountReportsPage.css';

const AccountReportsPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user) {
    return (
      <AccountLayout activeSection="reports">
        <div className="account-reports-auth-required">
          <div className="account-reports-auth-content">
            <h1>My Reports</h1>
            <p>Please sign in to access your saved reports.</p>
            <button onClick={() => navigate('/')} className="btn-primary">
              Go to ZoningPal
            </button>
          </div>
        </div>
      </AccountLayout>
    );
  }

  return (
    <AccountLayout activeSection="reports">
      <div className="account-reports-page">
        <div className="account-reports-header">
          <h1>My Reports</h1>
          <p className="account-reports-subtitle">
            View, download, and manage your saved zoning analysis reports. Create new reports by analyzing properties in the main application.
          </p>
        </div>

        <div className="account-reports-content">
          <SavedReports />
        </div>

        {/* Quick Actions Footer */}
        <div className="account-reports-actions">
          <div className="reports-action-card">
            <div className="reports-action-content">
              <h3>Need more reports?</h3>
              <p>Go to the main application to analyze Toronto properties and generate new zoning reports with our AI-powered analysis.</p>
            </div>
            <button 
              className="btn-primary"
              onClick={() => navigate('/')}
            >
              Start New Analysis
            </button>
          </div>
        </div>
      </div>
    </AccountLayout>
  );
};

export default AccountReportsPage; 